import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';


import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Provider as MobxProvider } from '@vromo/mobx-react';

import { useSocket } from '@vromo/websockets/websockets';
import { LIMITED_GRAPHSCHEMA_LIVESITE } from '@vromo/api/graph';
import { RootStore } from '@vromo/dashboard/src/stores/RootStore';

import queryString from 'query-string';

import ErrorModal from '@vromo/vendors/common/ErrorModal';
import { Site } from '@vromo/models';
import { prodBackend } from '@vromo/api/constants'

const DispatchPage = React.lazy(
    () => import('@vromo/dashboard/src/dispatch/Dispatch.lazy')
);


export default observer<RouteComponentProps<{ auth: string }>>(function LiveSite({ match, location }) {
    // it is known that the react.router is going to pass auth as param
    const { auth } = match.params
    const host = queryString.parse(location.search).host || prodBackend;

    const [siteExists, setSiteExists] = useState(true);

    const rootStore = new RootStore();

    runInAction(() => {
        rootStore.authStore.user.apiHost = host.toString();
        rootStore.authStore.token = auth;
        rootStore.authStore.graphSchema = LIMITED_GRAPHSCHEMA_LIVESITE;

        rootStore.viewStore.filters.drivers.offline = true; // Show all drivers for a site since filters are hidden
    });

    const { graph } = rootStore.authStore;

    useEffect(() => {
        graph.limited
            .graph()
            .get()
            .then((site: Site) => {
                rootStore.siteStore.loaded = true;
                rootStore.siteStore.sites.push(site);
            })
            .catch(() => {
                setSiteExists(false);
            });
    }, []);

    useSocket(
        graph.limited.graph().dashboard().socketUrl(),
        rootStore.vehicleStore.vehicles,
        () => (rootStore.vehicleStore.loaded = true),
        ({ vehicles }) => vehicles
    );

    useSocket(
        graph.limited.graph().dashboard().socketUrl(),
        rootStore.jobStore.jobs,
        () => (rootStore.jobStore.loaded = true),
        ({ jobs }) => jobs
    );

    return (
        <MobxProvider rootStore={rootStore}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100vw',
                    height: '100vh'
                }}>
                <DispatchPage />
                <ErrorModal isOpen={!siteExists} />
            </div>
        </MobxProvider>
    );
});
